import React from 'react';
import { useSelector } from 'react-redux';
import { selectNoScopeValidationScope } from '../../../util/useSelectorFunctions';
import { ResourceType } from '../../../../resource/enumerations/ResourceType';
import { useNestedDialogFunction } from '../../../../../../react-commons/dialog-provider/UseNestedDialogFunction';
import { useDeleteResourceDialogFunction } from '../../../reusable-components/dialogs/UseDeleteResourceDialogFunction';
import {
    defaultGridElementDecoratorResource,
    useGridElementDecoratorActions,
    GridElementDecoratorMutationResourceSchema,
} from '../../../../resource/resources/artifacts/use_case/representation/gridElementDecoratorResource';
import { GridElementDecoratorEditDialog } from '../grid-element-decorator/GridElementDecoratorEditDialog';
import { GridElementDecoratorCreationDialog } from '../grid-element-decorator/GridElementDecoratorCreationDialog';
import { NonCollapsibleQueryStateComponent } from '../../../reusable-components/base/NonCollapsibleQueryStateComponent';
import { useMyForm } from '../../../../../../react-commons/hooks/useMyForm';
import { GridElementDecoratorContent } from '../grid-element-decorator/GridElementDecoratorContent';

export const GridElementDecoratorDisplay = ({
    parentId,
}: {
    parentId: string;
}) => {
    const deleteResourceDialogFunction = useDeleteResourceDialogFunction();
    const nestedDialog = useNestedDialogFunction();

    const noScope = useSelector(selectNoScopeValidationScope);

    const gridElementDecoratorActions = useGridElementDecoratorActions()
    const gridElementDecoratorQuery = gridElementDecoratorActions.useGetSingleResource(parentId);
    const validationQuery = gridElementDecoratorActions.useValidateResource(
        gridElementDecoratorQuery.data?.id,
        noScope,
    );
    const deleteGridElementDecorator = gridElementDecoratorActions.useDeleteResource();

    const { form, formNames } = useMyForm({
        schema: GridElementDecoratorMutationResourceSchema,
        defaultValues: defaultGridElementDecoratorResource,
        reactiveValues: gridElementDecoratorQuery.data,
    });

    const openEditDialog = () => {
        const resource = gridElementDecoratorQuery.data;
        if (resource) {
            nestedDialog.showNestedDialog(
                <GridElementDecoratorEditDialog
                    onClose={nestedDialog.closeNestedDialog}
                    objectId={resource.objectId}
                    versionedInId={resource.versionedIn}
                />,
            );
        }
    };

    const openAddDialog = () => {
        nestedDialog.showNestedDialog(
            <GridElementDecoratorCreationDialog
                onClose={nestedDialog.closeNestedDialog}
                parentId={parentId}
            />,
        );
    };

    return (
        <NonCollapsibleQueryStateComponent
            query={gridElementDecoratorQuery}
            resourceType={ResourceType.GRID_ELEMENT_DECORATOR}
            label={'Grid Element Decorator'}
            readOnly={true}
            validationResource={validationQuery.data}
            handleAddClick={openAddDialog}
            handleEditClick={openEditDialog}
            handleDeleteClick={() => {
                const resource = gridElementDecoratorQuery.data;
                if (resource) {
                    deleteResourceDialogFunction.deleteResource(
                        resource.id,
                        undefined,
                        ResourceType.GRID_ELEMENT_DECORATOR,
                        deleteGridElementDecorator,
                    );
                }
            }}
        >
            <GridElementDecoratorContent form={form} formNames={formNames} readOnly={true} id={gridElementDecoratorQuery.data?.id} />
        </NonCollapsibleQueryStateComponent>
    );
};